const DEBUG = false;
class Analytics {
  // tag plan: https://docs.google.com/spreadsheets/d/1OrD6l43iqylQbICq2CO6eCgm5I8D6BgCdsAVXflRa7A/
  constructor() {
    window.dataLayer = window.dataLayer || [];
  }

  trigger(category, action, label = "", passive = "FALSE") {
    if (DEBUG) {
      console.log(
        "analytics trigger:",
        category,
        action,
        label,
        "nonInteraction:",
        passive
      );
    }
    window.dataLayer.push({
      event: "event",
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      nonInteraction: passive,
    });
  }

  introStart() {
    this.trigger("intro", "intro-start", "start", "TRUE");
  }
  skip() {
    this.trigger("intro", "intro-skip");
  }
  start() {
    this.trigger("intro", "experiment-start");
  }
  openSharePanel() {
    this.trigger("social", "open-panel", "open-panel");
  }
  shareFB() {
    this.trigger("social", "share", "facebook");
  }
  shareTwitter() {
    this.trigger("social", "share", "twitter");
  }
  shareLink() {
    this.trigger("social", "share", "link");
  }
  clickCluster(clusterName) {
    this.trigger("click", "cluster", clusterName);
  }
  clickAsset(assetId) {
    this.trigger("click", "assets", assetId);
  }
  clickGacLink(assetId) {
    this.trigger("click", "gac-link", assetId);
  }
  closeAsset() {
    this.trigger("click", "close-asset", "");
  }
  toggleStats(assetId) {
    this.trigger("click", "toggle-stats", assetId);
  }
}

export const analytics = new Analytics();
